// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_dc-0";
export var headerCellHover = "_dc-1";